export default "__VITE_ASSET__Cfa4hf9x__"